import React, {
  useContext,
  useState,
  useRef,
  useEffect,
} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { EventDatetimeContext } from 'components/EventDatetime';
import CircularLoadingIndicator from 'components/indicators/CircularLoadingIndicator';
import ScrollableContainerWrapper from 'components/ScrollableContainerWrapper';
import OnDemandWebinarList from 'pages/webinar/OnDemandWebinarList';
import { FETCH_ASSETS_URL } from 'appenv';
import { useTranslation } from 'react-i18next';
import FloatingFooter from 'components/footer_v2/FloatingFooter';
import Routes from 'Routes';

const EmptyStateImg = `${FETCH_ASSETS_URL}/assets/search-empty-state.svg`;

const WebinarListContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  overflow: auto;
`;

const LoadingIndicator = withStyles(() => ({
  root: {
    marginTop: '28px',
  },
}))(CircularLoadingIndicator);

const EmptyStateContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const EmptyStateText = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: #484848;
  padding: 24px;
`;

const OnDemandListContainer = ({ webinars, isLoading }) => {
  const { t } = useTranslation();
  const { isOnDemandWebinarReady } = useContext(EventDatetimeContext);

  const [scrollableTarget, setScrollableTarget] = useState();
  const scrollableTargetRef = useRef();

  useEffect(() => {
    setScrollableTarget(scrollableTargetRef.current);
  }, []);

  if (!isOnDemandWebinarReady || !webinars.length) {
    return (
      <EmptyStateContainer>
        <div>
          <img src={EmptyStateImg} alt="Coming Soon" />
          <EmptyStateText>
            {t('webinar.session.coming_soon', 'Coming Soon')}
          </EmptyStateText>
        </div>
      </EmptyStateContainer>
    );
  }

  return (
    <>
      <ScrollableContainerWrapper WrapperContainer={WebinarListContainer}>
        {
          isLoading ? (
            <LoadingIndicator />
          ) : (
            <OnDemandWebinarList webinars={webinars} />
          )
        }
        <FloatingFooter hashState={Routes.webinar} />
      </ScrollableContainerWrapper>
    </>
  );
};

OnDemandListContainer.propTypes = {
  webinars: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
};

OnDemandListContainer.defaultProps = {
  webinars: [],
};

export default OnDemandListContainer;
